import { Application } from "@hotwired/stimulus"
import HelloController from "./hello_controller"
import MenuController from "./menu_controller"
import ReactRootController from "./react_root_controller"


const application = Application.start()

application.register("hello", HelloController)
application.register("menu", MenuController)
application.register("react-root", ReactRootController)


export default application
